import { render, staticRenderFns } from "./CargoField.vue?vue&type=template&id=77cb9b50&scoped=true&"
import script from "./CargoField.vue?vue&type=script&lang=js&"
export * from "./CargoField.vue?vue&type=script&lang=js&"
import style0 from "./CargoField.vue?vue&type=style&index=0&id=77cb9b50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cb9b50",
  null
  
)

export default component.exports